import React from 'react';
import { Link } from 'react-router-dom';
import share_icon from '../../../assets/images/icons/user-dashboard/share-icon.png';
import del_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';
import CustomModalView from '../../../common/input/customModal/customModalView';
import ApplyModal from '../../find-jobs/ApplyModal';
import Table from 'react-bootstrap/Table';
import trash_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';
import moment from 'moment';
import DOMPurify from 'dompurify';

const PendingJobView = (props) => {
  console.log('++', Object.keys(props.data).length);
  return (
    <>
      <div className="dashboard-body-area">
        <section className="findjob-search-section">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-3 findjob-search-heading">
                <h2 className="cc-main_title--md">Find a job</h2>
              </div>
              <div className="col-md-8 findjob-search-bar">
                <div className="cc-searchbar">
                  <div className="srch-fld-row">
                    <div className="srch-fld-col">
                      <input type="text" placeholder="Postcode" />
                    </div>
                    <div className="srch-fld-col">
                      <select>
                        <option>Select Profession</option>
                        <option>Doctor</option>
                      </select>
                    </div>
                    <div className="srch-fld-col srch-btn-col">
                      <input
                        type="submit"
                        value=""
                        className="form-submit-btn"
                      />
                    </div>
                  </div>
                </div>
                <h5 className="job-search-info">
                  List of Jobs will apear based on the postcode given by user
                </h5>
              </div>
            </div>
          </div>
        </section>

        <section className="dashboard-page-title">
          <h2>Pending Jobs</h2>
        </section>
        <section>
          <div className="jobs-header">
            <div className="row">
              <div className="col-lg-6 d-sm-none d-lg-block">
                <h5>Total Jobs {props.data.length}</h5>
                <div className="list-view">
                  {props.list_active === 'active' ? (
                    <a href="" onClick={props.handelFormat} className="active">
                      <i className="fa fa-bars"></i>
                    </a>
                  ) : (
                    <a href="" onClick={props.handelFormat}>
                      <i className="fa fa-bars"></i>
                    </a>
                  )}
                  {props.card_active === 'active' ? (
                    <a href="" onClick={props.handelFormat} className="active">
                      <i className="fa fa-th-large"></i>
                    </a>
                  ) : (
                    <a href="" onClick={props.handelFormat}>
                      <i className="fa fa-th-large"></i>
                    </a>
                  )}
                </div>
              </div>
              <div className="col-lg-3 col-sm-12 pad-left-0 d-sm-none d-lg-block">
                <select className="select">
                  <option>View of Job</option>
                  <option>Popular Job 1</option>
                  <option>Popular Job 2</option>
                  <option>Popular Job 3</option>
                </select>
              </div>
              <div className="col-lg-3 col-sm-12 pad-left-0 d-sm-none d-lg-block">
                <select className="select">
                  <option>Sorting by</option>
                  <option>Popular Job 1</option>
                  <option>Popular Job 2</option>
                  <option>Popular Job 3</option>
                </select>
              </div>
            </div>
          </div>
        </section>
        <section className="wishlist-list-section">
          {/* jobs 1 start */}
          {props.card ? (
            props.data.map((jobs, index) => (
              <div className="job-box">
                <a
                  onClick={(e) => props.handelcompression(jobs.id)}
                  className="job-expand active"
                  data-id="job-1"
                ></a>
                <h2>{jobs.job_title}</h2>

                <div
                  className="jobs-details"
                  style={
                    props.expand_id === jobs.id
                      ? { display: props.expand }
                      : { display: 'none' }
                  }
                  id="job-1"
                >
                  <div className="job-requirement">
                    <div className="row">
                      <div className="col-sm-3">Job ID:</div>
                      <div className="col-sm-9">
                        <strong>{jobs.job_number}</strong>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">PostCode:</div>
                      <div className="col-sm-9">
                        <strong>{jobs.job_postcode}</strong>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">Requirement:</div>
                      <div className="col-sm-9">
                        <strong>Clinical Nurse Manager (CNM1)</strong>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-3">Qualification:</div>
                      <div className="col-sm-9">
                        <strong>
                          {props.return_string_data(jobs.job_qualifications)}
                        </strong>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">Experience:</div>
                      <div className="col-sm-9">
                        <strong>{jobs.job_experience} </strong>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">Language:</div>
                      <div className="col-sm-9">
                        <strong>{jobs.job_language}</strong>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">Remuneration:</div>
                      <div className="col-sm-9">
                        <strong>{jobs.job_renumeration}</strong>
                      </div>
                    </div>
                  </div>
                  <div className="job-description">
                    <h4>Job description</h4>
                    <p>
                      <span
                        className="more"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(jobs.job_description),
                        }}
                      ></span>
                    </p>
                  </div>
                </div>
                <div className="job-date">
                  <span>
                    {' '}
                    Start Date: {moment(jobs.start_date).format('DD-MM-YYYY')}
                  </span>
                </div>
                <div className="job-view">
                  <ul>
                    <li>
                      <i className="fa fa-eye"></i> Views{' '}
                      <span>{jobs.job_views}</span>{' '}
                    </li>
                    <li>
                      <i className="fa fa-wpforms"></i> Applications{' '}
                      <span>{jobs.application_count}</span>{' '}
                    </li>
                    <li>
                      <i className="fa fa-calendar"></i> Date Applied{' '}
                      <span>
                        {moment(jobs.date_applied).format('MMMM DD,YYYY')}
                      </span>{' '}
                    </li>
                    <li>
                      <i className="fa fa-calendar"></i> Closing Date{' '}
                      <span>
                        {moment(jobs.job_close_date).format('MMMM DD,YYYY')}
                      </span>{' '}
                    </li>
                  </ul>
                </div>
                <div className="job-btn">
                  <a href={'/job-details/' + jobs.job} className="btn-white">
                    Read More <i className="fa fa-angle-down"></i>
                  </a>
                  <a
                    href=""
                    onClick={(e) => props.acceptJobModal(jobs.id)}
                    className="btn-green"
                  >
                    ACCEPT JOB <i className="fa fa-arrow-right"></i>
                  </a>
                  <a
                    href=""
                    onClick={(e) => props.declineJobModal(jobs.id)}
                    className="btn-red"
                  >
                    DECLINE JOB <i className="fa fa-arrow-right"></i>
                  </a>

                  {/* <a className="btn-red">APPLY JOB <i className="fa fa-arrow-right"></i></a> */}
                  <div className="wistlist-box-share-del-action-list">
                    <ul>
                      <li>
                        <a href="" className="">
                          <img src={share_icon} alt="" />
                        </a>
                      </li>
                      <li>
                        <a href="" className="">
                          <img src={del_icon} alt="" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="table-area applied-job-table">
              {Object.keys(props.data).length > 0 ? (
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Applied on</th>
                      <th>Title</th>
                      <th>Job Type</th>
                      <th>Job Number</th>
                      <th>Zipcode</th>
                      <th>Address</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.data.map((jobs, index) => (
                      <tr>
                        <td>{jobs.date_applied}</td>
                        <td>{jobs.job_title}</td>
                        <td>{jobs.job_contract}</td>
                        <td>{jobs.job_number}</td>
                        <td>{jobs.job_postcode}</td>
                        <td>{jobs.job_city}</td>
                        <td>
                          <a
                            onClick={(e) =>
                              props.declineJobModal(jobs.id, jobs.shift)
                            }
                            className="del_btn"
                          >
                            <img src={trash_icon} />
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : null}
            </div>
          )}
        </section>
      </div>

      <CustomModalView
        modal_show={props.modal_show}
        authResponse={props.authResponse}
        showCustomModal={props.showCustomModal}
        hideCustomModal={props.hideCustomModal}
      />

      <ApplyModal
        apply_modal_show={props.apply_modal_show}
        applyHideCustomModal={props.applyHideCustomModal}
        applyjob={props.applyjob}
        shift_select_timing={props.shift_select_timing}
        handelShift={props.handelShift}
        applied_shift_id={props.applied_shift_id}
        apply_job_check={props.apply_job_check}
        applyfavorite={props.applyfavorite}
      />
    </>
  );
};
export default PendingJobView;
